// src/redux/saga/groupSaga.ts
import { PayloadAction } from '@reduxjs/toolkit';
import { message } from 'antd';
import { AxiosResponse } from 'axios';
import { put, takeLatest } from 'redux-saga/effects';
import { ISaveGroupRequest, ISaveGroupResponse } from 'redux/types/Agent.types';
import { agentGroupEndpoints } from 'services/api/endPoints';
import { HTTPClient } from 'services/api/http-client';

import {
  AgentGroup,
  fetchAgentGroup,
  fetchAgentGroupFailure,
  fetchAgentGroupSuccess,
  saveGroup,
  saveGroupFailure,
  saveGroupSuccess,
} from '../../slice/agent/AgentGroup.slice';

function* fetchAgentGroupSaga(action: PayloadAction<{ supervisorId: string }>) {
  try {
    const { supervisorId = '' } = action.payload;
    const response: AxiosResponse<AgentGroup[]> = yield HTTPClient.GetRequest(
      `${agentGroupEndpoints.VIEW_GROUPS(supervisorId)}`
    );
    message.success('Agents fetched');
    yield put(fetchAgentGroupSuccess(response.data));
  } catch (error) {
    yield put(fetchAgentGroupFailure('Failed to fetch groups'));
  }
}

function* saveGroupSaga(action: PayloadAction<ISaveGroupRequest>) {
  try {
    const groupData = action.payload;
    const response: AxiosResponse<ISaveGroupResponse> =
      yield HTTPClient.PostRequest(agentGroupEndpoints.SAVE_GROUP(), groupData);
    message.success('Group Created');
    yield put(saveGroupSuccess(response.data));
  } catch (error: any) {
    yield put(saveGroupFailure(error?.message));
  }
}

export function* watchFetchAgentGroupSagas() {
  yield takeLatest(fetchAgentGroup.type, fetchAgentGroupSaga);
  yield takeLatest(saveGroup.type, saveGroupSaga);
}
